import {
  LayoutGrid,
  Briefcase,
  Users,
  Calendar,
  Settings,
  Send,
  Bell,
} from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@project/lib/utils";
import { useAuth } from "@project/contexts/AuthContext";

const allNavItems = [
  {
    title: "Home",
    url: "/dashboard",
    icon: LayoutGrid,
    exact: true,
    roles: ["admin", "hr", "interviewer", "candidate"],
  },
  {
    title: "Jobs",
    url: "/jobs",
    icon: Briefcase,
    exact: false,
    roles: ["admin", "hr"],
  },
  {
    title: "Candidates",
    url: "/candidates",
    icon: Users,
    exact: false,
    roles: ["admin", "hr"],
  },
  {
    title: "Interviews",
    url: "/interviews",
    icon: Calendar,
    exact: false,
    roles: ["admin", "hr", "interviewer"],
  },
  {
    title: "More",
    url: "/settings",
    icon: Settings,
    exact: true,
    roles: ["admin", "hr", "interviewer", "candidate"],
  },
];

export function MobileBottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const navItems = allNavItems.filter(item =>
    item.roles.includes(user?.role || "admin")
  );
  const isActive = (item: (typeof allNavItems)[0]) => {
    if (item.exact) {
      return location.pathname === item.url;
    }
    return (
      location.pathname === item.url ||
      location.pathname.startsWith(item.url + "/")
    );
  };

  return (
    <nav className="safe-area-bottom fixed bottom-0 left-0 right-0 z-50 border-t border-border/60 bg-card/95 backdrop-blur-xl sm:hidden">
      <div className="flex items-center justify-around px-1 py-1.5">
        {navItems.map(item => {
          const active = isActive(item);
          return (
            <NavLink
              key={item.title}
              to={item.url}
              end={item.exact}
              className={cn(
                "flex min-w-[56px] flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 transition-all",
                active ? "text-primary" : "text-muted-foreground"
              )}
            >
              <div
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-xl transition-all",
                  active && "bg-primary/10"
                )}
              >
                <item.icon
                  className={cn("h-[18px] w-[18px]", active && "text-primary")}
                />
              </div>
              <span
                className={cn(
                  "text-[10px] font-medium leading-tight",
                  active && "font-semibold text-primary"
                )}
              >
                {item.title}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
